"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _makeQueryKey = _interopRequireDefault(require("../../../utils/make-query-key"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getProductFeedThreadsQueryKey = function getProductFeedThreadsQueryKey(_ref) {
  var productId = _ref.productId,
    styleColor = _ref.styleColor,
    fetchVasContent = _ref.fetchVasContent;
  return (0, _makeQueryKey["default"])(['product_feed/threads/v2', {
    productId: productId,
    styleColor: styleColor,
    fetchVasContent: fetchVasContent
  }]);
};
var _default = exports["default"] = getProductFeedThreadsQueryKey;